<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title><v-icon color="blue">mdi-format-list-bulleted</v-icon></v-toolbar-title>
      <base-breadcrumbs :items="breadcrumbs" />
    </v-toolbar>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="success" size="50">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <v-list-item-title>
                      <v-label color="caption"><small>Nama Kelompok PA </small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="body-1 black--text">
                        <strong> {{ $getDeepObj(detail, 'nama') || '-' }} </strong>
                      </span>
                      <div v-if="+$getDeepObj(detail, 'is_khusus') === 1" class="body-2 orange--text">
                        Kelompok Khusus
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-1">
                    <v-list-item-title>
                      <v-label color="caption"><small>Jadwal yang ditugaskan</small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle class="body-1 mt-1">
                      <div>
                        <div
                          class="black--text font-weight-medium"
                          v-if="$getDeepObj(config['pendampingan_ke-pmo'], `${current['pendampingan_ke_pmo']}`)"
                        >
                          {{ config['pendampingan_ke-pmo'][current['pendampingan_ke_pmo']] }}
                        </div>
                        <template v-else>-</template>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="2" sm="12">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-1">
                    <v-list-item-title>
                      <v-label color="caption"><small>Aksi </small></v-label>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div class="blue--text">
                        <v-btn
                          color="orange"
                          v-if="$allow('psp-peserta-kp-pa.update')"
                          dark
                          small
                          depressed
                          @click="onEdit(detail)"
                        >
                          <v-icon left>mdi-pencil</v-icon> Edit
                        </v-btn>
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>

            <v-expansion-panels flat class="my-2">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <div>
                      <v-toolbar flat>
                        <v-toolbar-title class="body-1 pa-0 ml-n5">
                          <span class="blue--text">
                            {{ ($getDeepObj(detail, 'psp_kp_pa_sekolahs.data') || []).length }}
                          </span>
                          Sekolah Anggota Pendampingan PA
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <span class="text-right blue--text">
                          {{ open ? 'Sembunyikan Daftar' : 'Lihat Selengkapnya' }}
                        </span>
                      </v-toolbar>
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="item in $getDeepObj(detail, 'psp_kp_pa_sekolahs.data') || []" :key="item.sekolah_id">
                    <v-col cols="12" md="6" sm="12">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <div class="blue--text body-1 mb-0 font-weight-medium">
                            {{ $getDeepObj(item, 'nama') || $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                          </div>
                          <div class="black--text">
                            <span class="font-weight-medium">NPSN: </span>
                            {{ $getDeepObj(item, 'npsn') || $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                          </div>
                          <div class="black--text">
                            <span class="font-weight-medium">Alamat: </span>
                            {{ $getDeepObj(item, 'alamat') || $getDeepObj(item, 'sekolah.data.alamat') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <v-list-item
                        class="px-0"
                        v-if="item.k_kp_kategori_psp && +$getDeepObj(detail, 'meta.pendampingan_tahun') < 2023"
                      >
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="mb-0">
                            <v-label color="caption"><small>Kategori Sekolah </small></v-label>
                          </v-list-item-title>
                          <div>
                            <v-icon :color="kategoris[item.k_kp_kategori_psp]" class="mr-0" size="30">
                              mdi-numeric-{{ item.k_kp_kategori_psp }}-circle
                            </v-icon>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Kepala Sekolah </small></v-label>
                          </v-list-item-title>
                          <div class="link black--text">
                            {{ $getDeepObj(item, 'psp_pelaksana.data.ptk.data.nama') || '-' }}
                          </div>
                          <div class="black--text">
                            <span class="font-weight-medium body-2">SIMPKB ID: </span>
                            {{ $getDeepObj(item, 'psp_pelaksana.data.ptk.data.id') || '-' }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-5" flat>
      <v-card-text class="black--text pa-5 mb-7">
        <v-row no-gutters class="mb-5">
          <v-col cols="12" lg="7" class="my-auto">
            <h3>Berikut Detail Jadwal Pertemuan</h3>
          </v-col>
          <v-col cols="12" lg="5" class="text-right">
            <v-chip color="success">Angkatan {{ detail.gelombang }} (tahun ke-{{ detail.tahun_ke }})</v-chip>
          </v-col>
        </v-row>
        <template v-if="kPertemuan">
          <template v-if="$getDeepObj(pendampingans, `${kPertemuan}`)">
            <v-tabs v-model="tab" hide-slider>
              <v-row>
                <template v-for="(item, i) in tabItems">
                  <v-col cols="12" :lg="12 / tabItems.length" :key="i">
                    <v-tab
                      :class="[
                        i === tab ? 'green lighten-4' : '',
                        'green--text text-capitalize body-2 font-weight-medium',
                      ]"
                      :disabled="item.disabled"
                      :key="i"
                      style="border: 1px solid #00bfa5; border-radius: 5px; width: 100% !important; max-width: 100%; height: 100%"
                    >
                      {{ item.title }}
                    </v-tab>
                  </v-col>
                </template>
              </v-row>

              <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
                <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
                  <v-col cols="12" lg="7">
                    <div class="body-1">
                      Pilih salah satu jadwal yang tersedia untuk melihat detail dari Jadwal Pertemuan <br />
                      <b>{{ $getDeepObj(detail, 'nama') || '-' }}</b>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="5" class="text-right">
                    <v-menu>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          depressed
                          x-large
                          style="background-color: #FDFFCF; border-radius: 5pt"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-row dense>
                            <v-col cols="10" class="text-left">
                              <span style="font-size: 10px" class="text-lowercase">
                                <span class="text-capitalize">Jadwal</span> yang ditampilkan
                              </span>
                              <p class="success--text mb-0 text-capitalize">
                                {{ (mPertemuan && mPertemuan[pendampingan_ke]) || '-' }}
                              </p>
                            </v-col>
                            <v-col cols="2">
                              <v-icon right dark color="#39C57B" class="pt-5">mdi-chevron-down</v-icon>
                            </v-col>
                          </v-row>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item-group v-model="pendampingan_ke" color="primary">
                          <template v-for="(item, key) in mPertemuan">
                            <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                            <v-list-item :key="key" link>
                              <v-list-item-title v-text="item"></v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
                <component
                  :is="item.component"
                  :details="details"
                  :kPertemuan="Number(kPertemuan)"
                  :sekolah="sekolah"
                  :grup="grup"
                  :versi="versi"
                  :dasars="dasars"
                  :pendampingan="detail"
                  :pendampingans="pendampingans"
                  :masters="masters"
                  :mPendampinganPmo="$getDeepObj(config, 'pendampingan_ke-pmo') || {}"
                  @edit="onEditPendampingan"
                  @toLink="toLink"
                  @toCopy="toCopy"
                  @view="onViewLaporan"
                ></component>
              </v-tab-item>
            </v-tabs>
          </template>
          <template v-else>
            <div class="text-center mt-5">
              <v-icon x-large>mdi-help-circle</v-icon>
              <div class="body-1 my-3">
                Belum ada pengaturan untuk <b>Jadwal Pertemuan {{ mPertemuan[pendampingan_ke] }}</b>
              </div>
              <div v-if="$allow('psp-peserta-kp-pa.update-pendampingan')" class="body-1">
                Anda dapat melakukan pengaturan melalui tombol berikut
              </div>
              <div class="mt-4">
                <v-btn
                  v-if="$allow('psp-peserta-kp-pa.update-pendampingan')"
                  color="primary"
                  depressed
                  @click="onEditPendampingan(kPertemuan)"
                >
                  <v-icon left>mdi-pencil</v-icon> Set Fasilitator
                </v-btn>
              </div>
            </div>
          </template>
        </template>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="1000">
      Tautan berhasil disalin
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          tutup
        </v-btn>
      </template>
    </v-snackbar>
    <base-modal-full
      ref="modal"
      :title="formulir.title"
      :useSave="formulir.useSave"
      @save="onSave"
      @close="onCloseModal"
    >
      <component
        ref="formulir"
        :is="formulir.form"
        :id="formulir.id"
        :initValue="formulir.init"
        :berkases="formulir.berkases"
        jenis="kp_pa"
        :grup="grup"
        :versi="versi"
        :dasars="dasars"
        :masters="masters"
        :nama="formulir.nama || ''"
        :gelombang="formulir.gelombang"
        :isPreview="formulir.isPreview"
      />
    </base-modal-full>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import mixin from './mixin';
import FormKelompok from '../formulir/Kelompok';
import FormPendampingan from '../formulir/Pendampingan';
import FormKuisioner from '../formulir/Kuisioner';
import FormKuisionerPA from '@views/gtk/diklat/pendampingan/formulir/Kuisioner.vue';
import FormIndividu from '../formulir/Individu';
import DetailUmum from '../component/DetailUmum';
import DetailPmo from '../component/DetailPmo';
import DetailIndividu from '../component/DetailIndividu';
import DetailPmo2023 from '@views/gtk/diklat/pendampingan/component/DetailPmo2023';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
export default {
  mixins: [mixin],
  components: {
    BaseBreadcrumbs,
    FormKelompok,
    FormPendampingan,
    FormKuisioner,
    FormKuisionerPA,
    FormIndividu,
    DetailUmum,
    DetailPmo,
    DetailPmo2023,
    DetailIndividu,
  },
  data() {
    return {
      detail: {},
      pendampingan_ke: null,
      kPertemuan: '',
      formulir: {},
      config: {},
      snackbar: false,
      tab: null,
      sekolah: [],
      dasars: [],
      grup: {},
      versi: 1,
      masters: {},
      autosave: null,
      alertBorang: false,
      mPendampingan: [],
      mPendampinganPmo: [],
      current: {},
      kategoris: {
        1: 'indigo',
        2: 'blue',
        3: 'cyan',
      },
    };
  },
  computed: {
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
    }),

    breadcrumbs() {
      return [
        { text: 'Daftar Kelompok Pendamping PA', to: 'diklat-pendampingan-pa' },
        { text: this.$getDeepObj(this.detail, 'nama') },
      ];
    },

    id() {
      return this.$route.params.detail_id || null;
    },

    akunId() {
      return this.$getDeepObj(this, 'preferensi.akun.akun_id');
    },

    keyAkses() {
      return 'psp-peserta-kp-pa.update-pendampingan';
    },

    mPertemuan() {
      if (this.tab === 1 || !(+this.detail.gelombang === 1 && +this.detail.tahun_ke === 1)) {
        const confPendampinganGel = this.$getDeepObj(this.config, 'pendampingan-gelombang') || [];
        let confPendampinganKePmo = Object.assign({}, this.$getDeepObj(this.config, 'pendampingan_ke-pmo') || {});

        for (const pendampinganKePmo in confPendampinganKePmo) {
          if (!confPendampinganGel.includes(+pendampinganKePmo)) {
            delete confPendampinganKePmo[pendampinganKePmo];
          }
        }

        return Object.values(confPendampinganKePmo) || [];
      }

      return Object.values((this.config && this.config['pendampingan_ke-pmo']) || {}) || [];
    },

    pendampingans() {
      return this.$arrToObj(this.$getDeepObj(this.detail, 'psp_kp_pa_pendampingans.data') || [], 'pendampingan_ke');
    },

    details() {
      let pendampingan = {};

      for (const kPertemuan in this.pendampingans) {
        const ptk = this.$getDeepObj(this.pendampingans[kPertemuan] || {}, 'psp_profil_pa.data.ptk') || {};

        if (this.$isObject(ptk)) {
          pendampingan = this.pendampingans[kPertemuan] || {};
        }

        if (+kPertemuan === this.kPertemuan) {
          break;
        }
      }

      const koordinators = this.$getDeepObj(pendampingan, 'psp_profil_pa.data.psp_kp_pa_koordinator_pas.data') || [];
      const koordinator = koordinators.filter((ko) => ko.pendampingan_tahun === this.current.pendampingan_tahun);

      return [
        {
          icon: 'mdi-account',
          title: `Nama Fasilitator`,
          value: this.$getDeepObj(pendampingan, 'psp_profil_pa.data.ptk.data.nama') || '',
          infos: [
            { label: 'Akun SIMPKB', value: this.$getDeepObj(pendampingan, 'psp_profil_pa.data.ptk.data.email') || '' },
            { label: 'No WA', value: this.$getDeepObj(pendampingan, 'psp_profil_pa.data.no_wa') || '' },
          ],
          grid: { cols: 12, md: 4, sm: 12 },
        },
        {
          icon: '',
          title: 'SIMPKB ID',
          value: this.$getDeepObj(pendampingan, 'psp_profil_pa.data.ptk_id') || '',
          grid: { cols: 12, md: 4, sm: 12 },
        },
        {
          icon: '',
          title: 'Nama Koordinator',
          value: this.$getDeepObj(koordinator[0] || {}, 'akun_koordinator.data.nama') || '-',
          grid: { cols: 12, md: 4, sm: 12 },
        },
      ];
    },

    tabItems() {
      const pendampinganTahun = this.$getDeepObj(this.detail, 'meta.pendampingan_tahun') || '';
      let deft = [
        { title: 'Fasilitator', disabled: false, component: 'DetailUmum' },
        {
          title: 'Laporan PMO',
          component: +pendampinganTahun >= 2023 ? 'DetailPmo2023' : 'DetailPmo',
        },
      ];

      let result = [...[], ...deft];
      if (+this.detail.gelombang === 1 && +this.detail.tahun_ke === 1) {
        result = [
          ...deft,
          ...[
            {
              title: 'Laporan Pendampingan Individu',
              disabled: false,
              component: 'DetailIndividu',
            },
            { title: 'Laporan Monev', disabled: true, component: 'DetailMonev' },
          ],
        ];
      }

      return result;
    },
  },
  created() {
    this.getPendampingan();
  },
  methods: {
    ...mapActions('diklatPa', {
      getDetail: 'getDetail',
      update: 'update',
      updatePendampingan: 'updatePendampingan',
      updateLaporan: 'updateLaporan',
      getSekolah: 'getSekolah',
      getInstrument: 'getInstrument',
      getPic: 'getPic',
    }),

    onSelectPertemuan(kPertemuan) {
      this.kPertemuan = kPertemuan;
      this.sekolah = [];
      this.getSekolahPendampingan(kPertemuan);
    },

    toLink(url) {
      window.open(url);
    },

    toCopy(url) {
      const elem = document.createElement('textarea');
      elem.value = url;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand('copy');
      document.body.removeChild(elem);
      this.snackbar = true;
    },

    getSekolahPendampingan(kPendampingan) {
      const pendampingan = this.$getDeepObj(this, `pendampingans.${kPendampingan || 1}`) || null;
      if (pendampingan && pendampingan.psp_kp_pa_pendampingan_id) {
        this.getSekolah({
          id: this.$getDeepObj(pendampingan, 'psp_kp_pa_pendampingan_id'),
          params: { count: 20 },
        }).then(({ data, meta }) => {
          this.sekolah = data || [];
          this.grup = meta?.grup || {};
          this.versi = meta?.versi || 1;
          this.dasars = Array.isArray(meta?.laporan_dasar) ? {} : meta?.laporan_dasar || {};
          const statusLengkap = this.sekolah.map((item) =>
            Boolean(this.$getDeepObj(item, 'psp_kp_pa_sekolah_laporans.data.0.is_lengkap') || 0)
          );
          this.alertBorang = statusLengkap.includes(false);
        });
      }
    },

    setPertemuan(value) {
      if (value === undefined) return;

      let mPendampingan = this.mPendampinganPmo;
      if (+this.detail.gelombang === 1 && +this.tahun_ke === 1) {
        mPendampingan = this.mPendampingan;
      }

      this.kPertemuan = mPendampingan[value || this.pendampingan_ke] || 0;
      this.getSekolahPendampingan(this.kPertemuan || 1);
    },

    onChangeTab() {
      let mPendampingan = this.mPendampinganPmo;
      if (+this.detail.gelombang === 1 && +this.detail.tahun_ke === 1) {
        mPendampingan = this.mPendampingan;
      }

      let confPendampinganKe = this.current['pendampingan_ke-pmo'] || '';
      if (+this.detail.gelombang === 1 && this.detail.tahun_ke === 1) {
        confPendampinganKe = this.current['pendampingan_ke'] || '';
      }
      const pendampinganKe = mPendampingan.indexOf(confPendampinganKe);
      this.pendampingan_ke = pendampinganKe > -1 ? pendampinganKe : 0;
    },
  },

  watch: {
    pendampingan_ke: 'setPertemuan',
    tab: 'onChangeTab',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
